import React, { useMemo } from 'react'
import { Typography } from 'antd'
import { TimeSlot } from '../types'
import { formatTime } from '../utils/timeUtils'
import { PIXELS_PER_15_MIN } from '../utils/timeUtils'

const { Text } = Typography

interface TimeColumnProps {
  timeSlots: TimeSlot[]
  highlightHour?: number | null
  hideHighlightLabel?: boolean
}

const TimeColumn: React.FC<TimeColumnProps> = ({ timeSlots, highlightHour, hideHighlightLabel }) => {
  const columnStyle: React.CSSProperties = useMemo(() => ({
    position: 'relative',
    height: (timeSlots.length - 1) * PIXELS_PER_15_MIN,
  }), [timeSlots])
  return (
    <div className="time-column" style={columnStyle}>
      {timeSlots.slice(0, -1).map((slot, index) => (
        <div
          key={slot.time}
          className={`time-slot ${slot.minute === 0 ? 'hour' : ''}`}
          style={{ position: 'absolute', height: PIXELS_PER_15_MIN, top: index * PIXELS_PER_15_MIN }}
        >
          {slot.minute === 0 && (
            <Text
              type="secondary"
              className="time-label"
            >
              {formatTime(slot.time)}
            </Text>
          )}
        </div>
      ))}
    </div>
  )
}

export default TimeColumn